<div mat-dialog-content>
  <h1>Select Forms</h1>

  <div class="search-container">
    <mat-form-field appearance="outline" floatLabel="always" style="width: 100%;">
      <mat-label>Search Forms</mat-label>
      <input matInput [(ngModel)]="q" name="q" (keyup)="onKeyUp($event)" autocomplete="off" spellcheck="off">
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>

    <mat-progress-bar *ngIf="dataLoading" color="primary" mode="indeterminate"></mat-progress-bar>
  </div>

  <div class="table" *ngIf="items.length > 0; else elseNoResults">
    <table mat-table class="dataset" [dataSource]="items">
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox (change)="$event ? masterToggle() : null"
                        [checked]="selection.hasValue() && isAllSelected()"
                        [indeterminate]="selection.hasValue() && !isAllSelected()">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox (click)="$event.stopPropagation()"
                        (change)="$event ? selection.toggle(row) : null"
                        [checked]="selection.isSelected(row)">
          </mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="thumbnail">
        <th mat-header-cell *matHeaderCellDef>Form</th>
        <td mat-cell *matCellDef="let element" class="column-thumbnail">
          <ng-container *ngIf="element.document; else elseNoDocument">
            <img [src]="element.document.thumbnail" class="thumbnail" *ngIf="element.document.thumbnail" />
          </ng-container>
          <ng-template #elseNoDocument>
            <div class="thumbnail">
              <i class="material-icons">ballot</i>
            </div>
          </ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <strong>
            <i class="material-icons flow-global" style="font-size: 17px;" *ngIf="element.global">lock</i> {{element.title}}
          </strong>

          <div style="margin-top: 3px;">
              <ng-container *ngIf="element.display_type === 'single'">
                Single page form
              </ng-container>

              <ng-container *ngIf="element.display_type === 'tabbed'">
                Tabbed form
              </ng-container>

              <ng-container *ngIf="element.display_type === 'wizard'">
                Multipage wizard
              </ng-container>

              <span class="label primary-light" *ngIf="element.internal" style="margin: 0 0 0 5px;">
                Internal
              </span>

              <span class="label primary" *ngIf="element.global" style="margin: 0 0 0 5px;">
                Flow Library
              </span>

              <span *ngIf="element.vehicle && element.vehicle.is_template" class="label primary" style="margin: 0 0 0 5px;">
                Template Form
              </span>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="appliesTo">
        <th mat-header-cell *matHeaderCellDef>Applies To</th>
        <td mat-cell *matCellDef="let element">
          <div class="iconic-status flex-container vertical-center">
            <i class="material-icons">
              {{documentService.ASSIGNABLE_ICONS[element.assignable_to]}}
            </i>
            {{documentService.ASSIGNABLE_TITLES[element.assignable_to]}}
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" [class.selected]="isItemSelected(row)" (click)="selection.toggle(row)"></tr>
    </table>
  </div>

  <ng-template #elseNoResults>
    <p *ngIf="!dataLoading">No forms found</p>
    <p *ngIf="dataLoading">Loading...</p>
  </ng-template>
</div>

<div class="footer-actions">
  <button class="close" (click)="onNoClick()">Close</button>
  <button class="select" [mat-dialog-close]="selection.selected">
    Select
    <ng-container *ngIf="selection.selected.length === 1">
      1 form
    </ng-container>
    <ng-container *ngIf="selection.selected.length > 1">
      {{selection.selected.length}} forms
    </ng-container>
  </button>
</div>
